import { Document, Page, StyleSheet, Text, View, Image } from "@react-pdf/renderer";
import MeratractorLogo from "../../../../img/logo2.png";
import FacebookIcon from "../../../../img/facebook.png";
import LinkedinIcon from "../../../../img/linkedin.png";
import TwitterIcon from "../../../../img/twitter.png";

const formatLegalDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });

  const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const ordinal = getOrdinalSuffix(day);
  return `${day}${ordinal} ${month} ${year}`;
};

const styles = StyleSheet.create({
  page: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    paddingTop: 90,
    paddingBottom: 120,
    paddingHorizontal: 50,
    lineHeight: 1.4,
  },
  // Header styles
  header: {
    position: "absolute",
    top: 20,
    left: 50,
    right: 50,
  },
  logoContainer: {
    alignItems: "flex-end",
    marginBottom: 8,
  },
  logo: {
    width: 180,
    height: 36,
  },
  redLine: {
    height: 2,
    backgroundColor: "#cc0000",
    marginTop: 5,
  },
  // Title
  title: {
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "Times-Bold",
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: 15,
    marginTop: 10,
  },
  // Reference section
  refSection: {
    marginBottom: 10,
  },
  refLine: {
    fontSize: 10,
    marginBottom: 2,
  },
  refLabel: {
    fontFamily: "Times-Bold",
  },
  // refValue: {
  //   textDecoration: "underline",
  // },
  // Address section
  addressSection: {
    marginBottom: 15,
  },
  addressText: {
    fontSize: 10,
    backgroundColor: "#ffff00",
  },
  // Paragraphs
  paragraph: {
    fontSize: 10,
    lineHeight: 1.5,
    textAlign: "justify",
    marginBottom: 10,
  },
  bold: {
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  italic: {
    fontStyle: "italic",
    fontFamily: "Times-Italic",
  },
  boldItalic: {
    fontWeight: "bold",
    fontStyle: "italic",
    fontFamily: "Times-BoldItalic",
  },
  subHeading: {
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Times-Bold",
    marginTop: 10,
    marginBottom: 8,
  },
  // Table styles
  table: {
    marginVertical: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableRowLast: {
    flexDirection: "row",
  },
  tableColLabel: {
    width: "40%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontSize: 9,
  },
  tableColValue: {
    width: "60%",
    padding: 5,
    fontSize: 9,
  },
  // SMA Table
  smaTable: {
    marginVertical: 10,
    borderWidth: 1,
    borderColor: "#000",
  },
  smaTableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  smaTableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  smaTableRowLast: {
    flexDirection: "row",
  },
  smaTableCol1: {
    width: "30%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 5,
    fontSize: 9,
  },
  smaTableCol2: {
    width: "70%",
    padding: 5,
    fontSize: 9,
  },
  // Signature section
  signatureSection: {
    marginTop: 30,
  },
  signatureLine: {
    marginTop: 40,
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 5,
    width: "40%",
  },
  acceptanceSection: {
    marginTop: 30,
  },
  // Footer styles
  footer: {
    position: "absolute",
    bottom: 20,
    left: 50,
    right: 50,
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 8,
  },
  footerCompanyName: {
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Times-Bold",
    color: "#000000",
    marginBottom: 3,
  },
  footerText: {
    fontSize: 7,
    lineHeight: 1.3,
    marginBottom: 2,
  },
  footerRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 5,
  },
  footerSocialContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 12,
  },
  footerSocialIcon: {
    width: 14,
    height: 14,
    marginRight: 3,
  },
  footerSocialText: {
    fontSize: 7,
  },
  followUsText: {
    fontSize: 7,
    marginRight: 8,
  },
});

const MTSanctionLetterPDF = ({ formData }) => {
  const refNo = formData?.otherDetails?.taFundingByMTReferenceNumber || formData?.referenceNumber || "KSOS/IF/XX/XX";
  const date = formatLegalDate(formData?.date);
  const businessType = formData?.businessType?.toLowerCase() || "";
  const isIndividual = businessType === "individual";
  const personName = formData?.personName || formData?.dealerName || "User Name";
  const companyName = formData?.companyName || "";
  const userName = isIndividual ? personName : (companyName ? `${companyName} (Prop:${personName})` : personName);
  const userAddress = formData?.address || "User Address";

  const Header = () => (
    <View style={styles.header} fixed>
      <View style={styles.logoContainer}>
        <Image style={styles.logo} src={MeratractorLogo} />
      </View>
      <View style={styles.redLine} />
    </View>
  );

  const Footer = () => (
    <View style={styles.footer} fixed>
      <Text style={styles.footerCompanyName}>Krishak Sevita Online Solutions Private Limited</Text>
      <Text style={styles.footerText}>
        <Text style={styles.bold}>Registered Office:</Text> Flat No 303, Building B, Kumar Gulmohar, Near Nancy Gardens, Wanawadi, Pune- 411040, Maharashtra, IN
      </Text>
      <Text style={styles.footerText}>
        CIN: U74900PN2015OPC156481  |  PAN: AAFCK9361C  |  GST No Maharashtra: 27AAFCK9361C1ZH
      </Text>
      <Text style={styles.footerText}>
        Visit us at www.meratractor.com write to us at contact@meratractor.com or call on <Text style={styles.bold}>8888009900</Text>
      </Text>
      <View style={styles.footerRow}>
        <Text style={styles.followUsText}>Follow us on</Text>
        <View style={styles.footerSocialContainer}>
          <Image style={styles.footerSocialIcon} src={FacebookIcon} />
          <Text style={styles.footerSocialText}>facebook.com/meratractor</Text>
        </View>
        <View style={styles.footerSocialContainer}>
          <Image style={styles.footerSocialIcon} src={LinkedinIcon} />
          <Text style={styles.footerSocialText}>linkedin.com/in/meratractor</Text>
        </View>
        <View style={styles.footerSocialContainer}>
          <Image style={styles.footerSocialIcon} src={TwitterIcon} />
          <Text style={styles.footerSocialText}>twitter.com/meratractor</Text>
        </View>
      </View>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <Header />

        <Text style={styles.title}>Sanction Letter</Text>

        <View style={styles.refSection}>
          <Text style={styles.refLine}>
            <Text style={styles.refLabel}>Reference No. </Text>
            <Text style={styles.refValue}>{refNo}</Text>
          </Text>
          <Text style={styles.refLine}>
            <Text style={styles.refLabel}>Date: </Text>
            <Text style={styles.refValue}>{date}</Text>
          </Text>
          <Text style={styles.refLine}>
            <Text style={styles.refLabel}>Name: </Text>
            <Text style={styles.refValue}>{userName}</Text>
          </Text>
        </View>

        <View style={styles.addressSection}>
          <Text style={styles.refLine}>
            <Text style={styles.refLabel}>Address- </Text>
            <Text style={styles.refValue}>{userAddress}</Text>
          </Text>
        </View>

        <Text style={styles.paragraph}>Dear Sir / Madam,</Text>

        <Text style={styles.paragraph}>
          Based on your application for the facility and information provided to us from time to time, we are giving a sanction as per the terms and conditions mentioned below.
        </Text>

        <Text style={styles.subHeading}>Terms and Conditions of the Facility</Text>

        <Text style={[styles.paragraph, styles.boldItalic]}>
          This summary of terms and conditions as set out in this sanction letter are indicative only and do not constitute a binding commitment of the Company to extend credit to or arrange financing to the user. The terms and conditions of the described transaction shall be set out in detail in the loan agreement and the definitive documents.
        </Text>

        {/* Main Terms Table */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>User Name</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>{userName}</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Company Name</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>Krishak Sevita Online Solutions Private Limited{"\n"}(KSOS)(Company)</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Type of Facility</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>Inventory Finance Facility</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Sanctioned Amount:</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>INR 10,00,000 (Revolving Limit)</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Purpose of the Facility:</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>Channel finance for purchase of used tractors</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Rate of Interest:</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text style={styles.bold}>18.00% P.A. (Rear Ended)</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Delayed Payment Charges (Default Interest Rate)</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text style={styles.bold}>36% P.A.</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Tenure:</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>120 days from date of disbursement (includes grace period that levies additional interest)</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Fee and Charges:</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text style={styles.bold}>Rs. 2000/-</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Cheque Bounce Charges</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text style={styles.bold}>Rs. 1000 + GST on every instrument bounce</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Stamp Duty and Registration Charges and any Goods and Service Taxes:</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>To be borne by the user</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Method of Calculation of Interest</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>
                Any interest, or fee accruing w.r.t. Invoice Financed will accrue from day to day and is calculated on the basis of the actual number of days elapsed and a year of 365 (Three Hundred and Sixty Five) days (or 366 days, in case of a leap year).
              </Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Pre-Payment</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>Allowed without any penalty</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Approach for Gradation of Risk</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>The Customer's Risk categorization and pricing is determined on the basis of the below mentioned factors:{"\n"}- Credit Bureau scores{"\n"}- Financial Position{"\n"}- Occupation/Business Profile{"\n"}- Repayment history{"\n"}- Collateral / Security</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Personal Guarantee</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text>NA</Text>
            </View>
          </View>

          <View style={styles.tableRowLast}>
            <View style={styles.tableColLabel}>
              <Text style={styles.bold}>Documentation</Text>
            </View>
            <View style={styles.tableColValue}>
              <Text style={styles.bold}>The user shall provide the following:{"\n"}1. Sanction Letter duly accepted.{"\n"}2. Loan Agreement & Legal Documentation{"\n"}3. Two SPDC favouring "Krishak Sevita Online Solutions Private Limited" along with covering letter.{"\n"}4. KYC Document</Text>
            </View>
          </View>
        </View>

        <Text style={styles.paragraph}>
          Classification as Special Mention Account (SMA) and Non-performing asset (NPA)
        </Text>

        {/* SMA Table */}
        <View style={styles.smaTable}>
          <View style={styles.smaTableHeader}>
            <View style={styles.smaTableCol1}>
              <Text style={styles.bold}>SMA Sub-categories</Text>
            </View>
            <View style={styles.smaTableCol2}>
              <Text style={styles.bold}>
                Basis for classification- Outstanding balance remains continuously in excess of the sanctioned limit or drawing power, whichever is lower, for a period of
              </Text>
            </View>
          </View>

          <View style={styles.smaTableRow}>
            <View style={styles.smaTableCol1}>
              <Text>SMA - 0</Text>
            </View>
            <View style={styles.smaTableCol2}>
              <Text>More than 0 days and upto 30 days</Text>
            </View>
          </View>

          <View style={styles.smaTableRow}>
            <View style={styles.smaTableCol1}>
              <Text>SMA - 1</Text>
            </View>
            <View style={styles.smaTableCol2}>
              <Text>More than 30 days and upto 60 days</Text>
            </View>
          </View>

          <View style={styles.smaTableRowLast}>
            <View style={styles.smaTableCol1}>
              <Text>SMA - 2</Text>
            </View>
            <View style={styles.smaTableCol2}>
              <Text>More than 60 days and upto 90 days</Text>
            </View>
          </View>
        </View>

        <Text style={styles.paragraph}>
          We will grant you this facility subject to the terms and conditions as contained in the loan agreement and other definitive documents.
        </Text>

        <Text style={styles.paragraph}>
          The offer is valid for 15 days from the date of issuance of this letter and will be extended at the sole discretion of the Company. In case of any inconsistency and repugnancy between the terms of this sanction letter and any loan document the provisions that are more favourable to the Company shall prevail and be binding on the user.
        </Text>

        <Text style={styles.paragraph}>
          The Company reserves the right to withdraw and/or amend any of the terms of conditions hereof (including to reduce or cancel the commitment in relation to this facility) at its sole discretion. Basis utilization of limits on month end, the company will have right to unilaterally reduce or reinstate the limit amount with intimation to the user.
        </Text>

        <Text style={styles.paragraph}>
          We value your relationship with us and assure you of our best services always.
        </Text>

        <Text style={styles.paragraph}>
          The letter is in duplicate. Please sign the duplicate as a token of your acceptance of terms and conditions mentioned above.
        </Text>

        <Text style={styles.paragraph}>Thanking you.</Text>
        <Text style={styles.paragraph}>Yours truly,</Text>
        <Text style={styles.paragraph}>For Krishak Sevita Online Solutions Private Limited (KSOS)</Text>

        <View style={styles.signatureSection}>
          <View style={styles.signatureLine}>
            <Text>Authorized Signatory</Text>
          </View>
        </View>

        <View style={styles.acceptanceSection}>
          <Text style={[styles.paragraph, styles.bold]}>
            We acknowledge, understand and accept the above terms and conditions
          </Text>

          <Text style={styles.paragraph}>
            For, <Text style={styles.refValue}>{userName}</Text> (Applicant)
          </Text>

          <View style={[styles.signatureLine, { marginTop: 60, width: "50%" }]}>
            <Text></Text>
          </View>
        </View>

        <Footer />
      </Page>
    </Document>
  );
};

export default MTSanctionLetterPDF;
